module.exports = __webpack_public_path__ + "static/media/Standard_ACH.eab5739f.svg";